import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { MaintenanceProvider } from "@/context/MaintenanceContext";
import { BrandingProvider } from "@/context/BrandingContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import MaintenanceGate from "@/components/MaintenanceGate";
import MaintenanceBanner from "@/components/MaintenanceBanner";
import ScheduledMaintenanceBanner from "@/components/ScheduledMaintenanceBanner";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Browse from "@/pages/Browse";
import MovieDetail from "@/pages/MovieDetail";
import Watch from "@/pages/Watch";
import CreatorDashboard from "@/pages/CreatorDashboard";
import UploadMovie from "@/pages/UploadMovie";
import ResumeUpload from "@/pages/ResumeUpload";
import AdminPanel from "@/pages/AdminPanel";
import CreatorRevenue from "@/pages/CreatorRevenue";
import CreatorAppeals from "@/pages/CreatorAppeals";
import SeriesDetail from "@/pages/SeriesDetail";
import About from "@/pages/About";
import SubmissionGuidelines from "@/pages/SubmissionGuidelines";
import Contact from "@/pages/Contact";
import AdminInviteAccept from "@/pages/AdminInviteAccept";
import Press from "@/pages/Press";
import GenrePage from "@/pages/GenrePage";
import HowPayoutsWork from "@/pages/HowPayoutsWork";
import Newsletter from "@/pages/Newsletter";
import Subscription from "@/pages/Subscription";
import PaymentCallback from "@/pages/PaymentCallback";
import Profile from "@/pages/Profile";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <MaintenanceProvider>
            <BrandingProvider>
            <Toaster theme="dark" position="top-right" richColors />
            <MaintenanceBanner />
            <ScheduledMaintenanceBanner />
            <Header />
            <main className="min-h-[calc(100vh-4rem)]">
              <MaintenanceGate>
                <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/browse" element={<Browse />} />
              <Route path="/movie/:id" element={<MovieDetail />} />
              <Route path="/series/:id" element={<SeriesDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/submission-guidelines" element={<SubmissionGuidelines />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/press" element={<Press />} />
              <Route path="/genres/:slug" element={<GenrePage />} />
              <Route path="/how-payouts-work" element={<HowPayoutsWork />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/watch/:id" element={
                <ProtectedRoute><Watch /></ProtectedRoute>
              } />
              <Route path="/creator" element={
                <ProtectedRoute roles={["creator", "admin"]}><CreatorDashboard /></ProtectedRoute>
              } />
              <Route path="/creator/upload" element={
                <ProtectedRoute roles={["creator", "admin"]}><UploadMovie /></ProtectedRoute>
              } />
              <Route path="/creator/resume/:id" element={
                <ProtectedRoute roles={["creator", "admin"]}><ResumeUpload /></ProtectedRoute>
              } />
              <Route path="/creator/revenue" element={
                <ProtectedRoute roles={["creator", "admin"]}><CreatorRevenue /></ProtectedRoute>
              } />
              <Route path="/creator/appeals" element={
                <ProtectedRoute roles={["creator", "admin"]}><CreatorAppeals /></ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute roles={["admin"]}><AdminPanel /></ProtectedRoute>
              } />
              <Route path="/subscription" element={
                <ProtectedRoute><Subscription /></ProtectedRoute>
              } />
              <Route path="/payment/callback" element={<PaymentCallback />} />
              <Route path="/invite/admin/:token" element={<AdminInviteAccept />} />
              <Route path="/profile" element={
                <ProtectedRoute><Profile /></ProtectedRoute>
              } />
                </Routes>
              </MaintenanceGate>
            </main>
            <Footer />
            </BrandingProvider>
            </MaintenanceProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
